import { FC, useEffect } from 'react'
import { RenderIf } from '../RenderIf'
import LoadingBar from 'react-redux-loading-bar'
import { Spinner } from 'featureSliced/entities/Spinner'
import { LoadingBarContainer, OverlayContainer } from './styled'

type SpinnerOverlayProps = {
  isLoading: boolean
  isTransparent?: boolean
}

export const SpinnerOverlay: FC<SpinnerOverlayProps> = ({
  isLoading,
  isTransparent,
}) => {
  const getBackgroundColor = () => {
    if (process.env.REACT_APP_IS_CLIC === '0') return '#FF8700'
    if (process.env.REACT_APP_IS_CLIC === '1') return '#C80008'
    return 'red'
  }

  return (
    <>
      <RenderIf condition={isLoading}>
        <OverlayContainer>
          <LoadingBarContainer>
            <LoadingBar
              style={{ backgroundColor: getBackgroundColor(), height: '5px' }}
            />
          </LoadingBarContainer>
          <Spinner type={isTransparent ? 'transparent' : 'default'} />
        </OverlayContainer>
      </RenderIf>
    </>
  )
}
